import React, { useCallback, useEffect, useRef } from 'react';

import { useForm } from '@mantine/form';

import { AddressFormValues, AddressFormWrapper } from '../../AddressForm/AddressForm';

type MailingAddressFieldProps = {
  required: boolean;
  id: string;
  onChange: (address: string) => void;
  /** An input prop from useForm
   * When present triggers validation from child form AddressFormWrapper
   */
  error: React.ReactNode;
};

/**
 *
 * An Additional Mailing Address Field
 * This passes a "Sudo" useFormValidator to the AddressFormWrapper
 * this is done so that we can access it's underlying form component.
 *
 */
const AdditionalMailingAddressField = ({
  required,
  id,
  onChange,
  error,
}: MailingAddressFieldProps) => {
  const formRef = useRef<ReturnType<typeof useForm<Record<string, unknown>>> | null>(null);

  const useFormValidator = useCallback(
    ({ form: _form }: { form: ReturnType<typeof useForm<Record<string, unknown>>> }) => {
      formRef.current = _form;
    },
    []
  );

  const handleChange = useCallback(
    (_, addressValueFormats: AddressFormValues) => {
      const isValid = formRef.current?.isValid();
      if (isValid) {
        onChange(addressValueFormats.asString);
      } else {
        onChange('');
      }
    },
    [onChange]
  );

  useEffect(() => {
    if (error) {
      formRef.current?.validate();
    }
  }, [error]);

  return (
    <AddressFormWrapper
      required={required}
      id={id}
      onChange={handleChange}
      useFormValidator={useFormValidator}
    />
  );
};

export { AdditionalMailingAddressField };
